import { memo, useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import Hamburger from "app/pages/Header/Hamburger/Hamburger";
import SidePanel from "app/pages/.shared/SidePanel/SidePanel";
import FaqAsideNav from "app/pages/Faq/FaqAsideNav/FaqAsideNav";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import { BackButton } from "app/pages/.shared/BackButton/BackButton";
import "./FaqHeader.scss";
import RelativeLink from "app/pages/.shared/RelativeLink";
import AppGlobalsContext from "app/AppGlobalsContext";
import FaqSearch from "app/pages/Faq/FaqSearch/FaqSearch";
import { useLocation } from "react-router-dom";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { sendTagOnFaqAsideMobileNavOpen } from "app/utils/analytics";

const FaqHeader = ({ faqCategories }) => {
	const [isSidePanelOpen, toogleSidePanel] = useState(false);

	const { pathname } = useLocation();

	const isFaqHome = pathname === "/faq";

	const { resolution } = useContext(AppGlobalsContext);

	const handleHamburgerClick = useCallback(() => {
		if (!isSidePanelOpen) {
			sendTagOnFaqAsideMobileNavOpen();
		}
		toogleSidePanel(!isSidePanelOpen);
	}, [isSidePanelOpen]);

	const handleOnPanelClose = useCallback(() => {
		toogleSidePanel(false);
	}, [isSidePanelOpen]);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	return (
		<header className="faq-header">
			<div className="faq-header__container">
				<div className="faq-header__logo">
					{!isFaqHome && (
						<div className="faq-header__back">
							<BackButton forceBrowserBack />
						</div>
					)}
					<RelativeLink to={{ pathname: "/faq" }} data-testid="header-back-link">
						<LogoBrandContainer />
					</RelativeLink>
				</div>
				<div className="faq-header__hamburger">
					<Hamburger onToogle={handleHamburgerClick} isActive={isSidePanelOpen} />
					<SidePanel
						isOpen={isSidePanelOpen}
						onClose={handleOnPanelClose}
						direction={"rtl"}
					>
						<FaqAsideNav faqCategories={faqCategories} />
					</SidePanel>
				</div>
				{!isMobile && !isFaqHome && (
					<div className="faq-header__search">
						<FaqSearch />
					</div>
				)}
			</div>
		</header>
	);
};

FaqHeader.propTypes = {
	faqCategories: PropTypes.array,
};

export default memo(FaqHeader);
